import textHelper from '@/helpers/textHelper';

export default {
  state: {
    surgeries: []
  },
  getters: {
    surgeries: state => state.surgeries
  },
  mutations: {
    setSurgeries(state, surgeries) {
      state.surgeries = surgeries;
    },
    addSurgery(state, surgery) {
      state.surgeries.push(surgery);
    },
    updateSurgery(state, surgery) {
      const idx = state.surgeries.findIndex(s => s.id === surgery.id);
      state.surgeries.splice(idx, 1, surgery)
    },
    deleteSurgeries(state, surgeries) {
      for (const { id } of surgeries) {
        const idx = state.surgeries.findIndex(s => s.id === id);
        state.surgeries.splice(idx, 1);
      }
    }
  },
  actions: {
    addSurgery({ commit, rootState, rootGetters }, surgery) {
      surgery.userId = rootGetters.user.id
      return fetch(`${process.env.VUE_APP_API_URL}/users/${rootGetters.user.id}/logs`,
        {
          headers: { 'Content-Type': 'application/json', 'authorization': `Bearer ${rootState.auth.accessToken}` },
          method: 'POST',
          body: JSON.stringify(surgery)
        }
      )
      .then(res => res.json())
      .then(surgery => {
        return commit('addSurgery', textHelper.setTextsLogBookElement(surgery, rootState.langValue))
      })
    },
    setSurgeries({ commit, rootState }, surgeries) {
      commit('setSurgeries', textHelper.setTextsLogBookCollection(surgeries), rootState.langValue);
    },

    getSurgeries({ commit, rootState }, license) {
      return fetch(`${process.env.VUE_APP_API_URL}/users/${license}/logs`, 
      {
        headers: { 'authorization': `Bearer ${rootState.auth.accessToken}` }
      })
      .then(res => res.json())
      .then(surgeries => {
          commit('setSurgeries', textHelper.setTextsLogBookCollection(surgeries), rootState.langValue)
      })
    },

    deleteSurgeries({ commit, rootState }, surgeries) {
      const surgeryIds = surgeries.map(s => s.id).join(';');
      return fetch(`${process.env.VUE_APP_API_URL}/users/${rootState.user.id}/logs?ids=${surgeryIds}`,
        {
          method: 'DELETE',
          headers: { 'authorization': `Bearer ${rootState.auth.accessToken}` }
        })
        .then(() => {
          commit('deleteSurgeries', surgeries)
        })
    },
    
    updateSurgery({ commit, rootState }, surgery) {
      return fetch(`${process.env.VUE_APP_API_URL}/users/${rootState.user.id}/logs/${surgery.id}`,
        {
          method: 'PUT',
          body: JSON.stringify(surgery),
          headers: { 'Content-Type': 'application/json', 'authorization': `Bearer ${rootState.auth.accessToken}` }
        })
        .then(res => res.json())
        .then(surgery => {
          return commit('updateSurgery', textHelper.setTextsLogBookElement(surgery, rootState.langValue))
        })
    },
  }
}
